import { useNavigate } from 'react-router';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { CreateGoogleHolidaysDto } from '../../../commonTypes/organization.types';
import { useContainer } from '../../useContainer';
import { resetImportGoogleHolidaysState } from '../../../store/slices/import-holidays.slice';
import { dispatch } from '../../../store';
import { useTranslation } from '../../useTranslation';

const useHttpPostGoogleHolidays = () => {
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler = useContainer(ToastStateHandler);
    const navigate = useNavigate();

    const exec = (body: CreateGoogleHolidaysDto) => {
        const { exec, abort } = organizationApi.postGoogleHolidays({
            body,
            onSuccess: _ => {
                toastHandler.push('success', t('holiday.importHolidaysTitle'), t('holiday.importHolidaysMessage_Success'));
            },
            onError: error => {
                toastHandler.push('error', t('holiday.importHolidaysTitle'), t('holiday.importHolidaysMessage_Failed'));
                console.log(error);
            },
            onFinally: () => {
                navigate(`/holidays`);
                dispatch(resetImportGoogleHolidaysState());
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPostGoogleHolidays;
